export default __webpack_public_path__ + "static/media/occipital_norm.67d22218.webp";